import { observer } from 'mobx-react';
import * as React from 'react';
import { ActiveProgram, ActiveProgramModule } from '../../../../../ProgramStore/Types';
import { TranslationsState } from '@execonline-inc/translations';
import { isJust, Maybe } from 'maybeasy';
import { fromArrayMaybe } from 'nonempty-list';
import { when } from '@execonline-inc/maybe-adapter';
import ScheduledRunLate from './ScheduledRunLate';
import ScheduledRunOnTrack from './ScheduledRunOnTrack';

interface Props {
  programDetail: ActiveProgram;
  translationsState: TranslationsState;
}

const getCurrentModule = (programDetail: ActiveProgram): ActiveProgramModule[] =>
  programDetail.modules.filter((m) => m.isCurrentModule && isJust(m.endsOn));

const getCurrentModuleEndDate = (programDetail: ActiveProgram): Maybe<Date> =>
  fromArrayMaybe(getCurrentModule(programDetail)).andThen(
    (currentModule) => currentModule.first.endsOn,
  );

const pastModuleEndDate = (moduleEndsOn: Date): Maybe<Date> => {
  const today = new Date();
  return when(today > moduleEndsOn, moduleEndsOn);
};

const ScheduledRun: React.FC<Props> = ({ programDetail, translationsState }) => {
  const { percentComplete } = programDetail;

  return programDetail.hideProgramProgressAlerts
    .map(() => (
      <ScheduledRunOnTrack programDetail={programDetail} translationsState={translationsState} />
    ))
    .getOrElse(() =>
      getCurrentModuleEndDate(programDetail)
        .andThen((date) => pastModuleEndDate(date))
        .map((date) => (
          <ScheduledRunLate
            moduleEndsOn={date}
            percentComplete={percentComplete}
            translationsState={translationsState}
          />
        ))
        .getOrElse(() => (
          <ScheduledRunOnTrack
            programDetail={programDetail}
            translationsState={translationsState}
          />
        )),
    );
};

export default observer(ScheduledRun);
